import * as types from './types'
import http from '@/Plugins/api'

export default {
  setRecipients({ commit }, data) {
    commit(types.SET_RECIPIENTS, data)
  },
  setCannedMessageData({ commit }, data) {
    commit(types.SET_CANNEDMESSAGE_DATA, data)
  },
  resetCannedMessage({ commit }, data) {
    commit(types.RESET_CANNEDMESSAGE, data)
  },
  async getCannedMessages({ commit }, id) {
    const r = await http.get(`v2/cannedmessages/${id}`)
    commit(types.SET_CANNEDMESSAGES, r.data.data)
    return r.data.data
  },
  async getCannedMessage({ commit }, id) {
    const r = await http.get(`v2/cannedmessages/edit/${id}`)
    commit(types.SET_CANNEDMESSAGE, r.data.data)
    return r.data.data
  },
  async saveCannedMessage({ commit }, data) {
    let r = null
    if (data.id === null) {
      r = await http.post('v2/cannedmessages', data)
    } else {
      r = await http.put('v2/cannedmessages', data)
    }
    return r.data.data
  },
  async removeCannedMessage({ commit }, id) {
    const r = await http.delete(`v2/cannedmessages/${id}`)
    return r.data.data
  },
  async saveMessage({ commit }, data) {
    const r = await http.post(`v2/messages`, data)
    return r.data.data
  },
  async saveBatchMessage({ commit }, data) {
    const r = await http.post(`v2/batchMessages`, data)
    return r.data.data
  },
}
